<template>
  <div :class="['protocol-container', isMobile ? 'mobile' : '', isMinip ? 'minip' : '']">
    <div class="protocol">
      <p class="title">魔音工坊付费视频服务协议</p>
      <div class="update-data">
        <p class="time compact">发布日期：2024年02月08日</p>
        <p class="time compact">生效日期：2024年02月08日</p>
      </div>
      <div class="container">
        <p>欢迎您使用魔音工坊剪同款付费视频服务！</p>
        <p class="highlight">
          在使用魔音工坊剪同款付费视频服务（以下简称“本服务”）之前，您（以下简称“您”或“用户”）应当阅读并遵守《魔音工坊付费视频服务协议》（以下简称“本协议”）。请您务必审慎阅读、充分理解各条款内容，特别是免除或限制责任条款、法律适用和争议解决条款。
        </p>
        <p>
          当您根据本服务页面提示的购买程序成功支付费用后，即被视为完成购买并可享受本服务。您以其他任何明示或者默示方式表示接受本协议，或您以其他本服务允许的方式实际使用本服务时，即表示您已充分阅读、理解并接受本协议的全部内容，本协议即产生法律约束力。
          <span class="highlight">
            您承诺接受并遵守本协议的约定，届时您不应以未阅读本协议的内容或者未获得我们对您问询的解答等理由，主张本协议无效，或要求撤销本协议。
          </span>
        </p>
        <p>
          请您注意，我们可能会不时检查并更新本协议，因此有关本协议的内容会随之变化。如果您继续使用本服务，即视为您已充分理解并同意我们对本协议的更新修改。如果您不接受我们对本协议的更新修改，应立即停止使用本服务。
        </p>
        <p class="title">一、缔约主体</p>
        <p>
          本协议由您与北京小问智能科技有限公司（注册地为【北京市海淀区高梁桥斜街42号院1号楼7层1-729】）及所有关联公司
          (以下简称“我们”、“公司”）共同缔结，本协议对您与我们均有合同效力。
        </p>
        <p class="title">二、定义</p>
        <p>
          1、本服务：也即魔音工坊剪同款付费视频服务，是由公司提供的付费视频合成服务，主要包括使用模板合成视频，并可在完成购买后导出、下载、分享该模板生成后的视频。（具体服务内容应以本协议及本服务详情页或购买页信息为准）。 
        </p>
        <p>
          2、模板：指公司拥有合法权利或经相关权利人合法授权而在魔音工坊产品及服务相关区域上传、发布的视频模板。
        </p>
        <p class="title">三、本协议的内容和确认</p>
        <p>
          1、本协议包括本协议正文及所有本服务已经发布或将来可能发布的
          <a href="/#/protocol">《魔音工坊用户协议》</a>
          、
          <a href="/#/privacy">《魔音工坊隐私政策》</a>
          、各项政策、规则声明、通知、警示、提示、说明（以下统称“服务协议及规则”）。前述规则为本协议不可分割的组成部分，与本协议具有同等法律效力。本协议未尽事宜，以前述服务协议及规则为准。
        </p>
        <p>
          2、您须先成为魔音工坊普通注册用户之后，才能购买、使用本服务。您在本服务购买页面点击“提交订单”或“确认支付”等确认按钮且根据提示确认支付服务费用，并通过本协议第5.2条约定的支付方式之一成功支付费用后，视为您完成本服务的购买。之后，您可以导出、下载、分享模板生成后的视频。如您未完成服务费用的支付，则视为您未完成本服务的购买，您无法导出、下载、分享该付费模板生成后的视频。
        </p>
        <p class="highlight">
          3、若您为中国大陆地区以外的用户，您还需要同时遵守您所属和/或所处国家或地区的相关法律。
        </p>
        <p>
          4、对于未明确授权予您的本服务（包括但不限于模板和/或其他相关服务）的权利、收益均归属于公司或其他相关权利方
        </p>
        <p class="title highlight">四、服务内容及服务使用规范</p>
        <p>1、您理解并同意：</p>
        <p>（1）对于您未完成购买的本服务，您可以在模板编辑页对草稿内容进行编辑。</p>
        <p>
          （2）对于您完成购买的本服务，您可以导出、下载模板生成后的视频，也可以将使用模板生成后的视频分享至本服务支持的其他第三方平台。
          若您需导出使用模板生成后的视频，则每次均需按照详情页中所展示的具体标价支付费用。当您完成前述费用支付后，您可以多次下载和分享该模板生成后的视频。
        </p>
        <p>
          （3）您完成本服务的购买，并不因此获得公司模板、添加的视频、音乐、人物肖像、图片、贴纸、字体等各类素材及特殊素材效果（包括但不限于变形、抠像等）的任何使用授权。
        </p>
        <p>（4）您无权将“模板”在其他任何平台、渠道发布为模板。</p>
        <p>（5）本服务的具体权益内容以您具体完成购买的服务实际为准。</p>
        <p class="highlight">
          2、本服务为虚拟服务，因您支付的费用是本服务的销售金额，不具备非预付款或者存款、定金、储蓄卡等法律属性，除非因本服务存在重大瑕疵导致用户完全无法使用、法律法规要求必须退款外，一经支付后不可转让或退款。
        </p>
        <p class="highlight">
          3、您理解并同意，对于您已完成购买的本服务，您只能用于个人访问、使用，不得用于任何商业性等用途，包括但不限于出售、转让、许可或以其他方式使除您自己以外的第三方使用等。若您违反本条款，公司有权进行独立判断并对您采取警示、限制功能、暂停服务、关闭账号等处置措施，若由此给您带来的损失应由您自行承担。公司并有权要求您支付您由此获得的收益，若您违反本条款给公司和/或其他权利人造成损失的，您应予赔偿。
        </p>
        <p class="highlight">
          4、您应为您自己购买或使用本服务及与本服务相关的的全部行为独立承担责任，包括但不限于您发表内容、分享等行为。因您的行为导致您自身或其他任何第三方遭受任何损失或损害的，公司不承担任何责任。您应对本服务内容自行加以判断并独立承担因使用内容而引起的所有风险。因前述风险导致的损失或损害与公司无关。
        </p>
        <p class="highlight">
          5、您保证，在使用本服务时上传、分享的文字、图片、音视频等不侵犯任何第三方的知识产权、名誉权、姓名权、隐私权等权利及合法权益。若第三方提出权利或主张，您应自行处理并承担因此产生的全部法律责任，同时，本公司有权不经通知随时对相关内容进行删除、屏蔽，并采取包括但不限于收回帐号，限制、暂停、终止您使用部分或全部本服务。如因您的行为给公司或关联公司造成损失的，您应予全额赔偿。
        </p>
        <p class="highlight">
          6、您在本服务中使用第三方提供的软件及/或相关服务时，或您将本服务、使用模板生成后的视频等分享至第三方时，除遵守本协议外，还应遵守第三方的协议、相关规则。因第三方软件及/或相关服务产生的任何问题，由您自行与第三方解决，公司不对您或任何第三方承担责任。
        </p>
        <p class="title">五、本服务购买方式</p>
        <p>1、我们会在本服务购买页面上提供购买步骤的明确提示，请您在购买过程中认真阅读</p>
        <p>
          2、费用支付：您在本服务购买页面点击“提交订单”或“确认支付”等确认按钮后，您将按照您购买时服务页面标明的价格通过“支付宝”、“微信支付”、“iOS
          App内购买”等第三方支付服务商代收费的方式向公司完成服务费用支付。
        </p>
        <p>
          3、完成本服务的购买后，您可在“我的”-“作品管理”-“剪辑作品”-“我的成片”中导出、下载、分享使用模板合成后的视频
        </p>

        <p class="title">六、服务费用标准</p>
        <p>
          1、本服务由公司自行定价并在购买页面明确标明价格，具体每项服务的收费标准应以购买页面所展示的具体标价为准。一旦您完成购买本服务，即视为您认可前述价格；您理解并同意公司有权对价格进行变动，并愿意承担价格变动的风险。如您不同意收费应当立即停止服务的使用，否则使用则视为您已同意并应当缴纳费用。公司收到相应服务费用后，您购买的相关服务即时生效。
        </p>
        <p>
          2、所有费用需通过公司接受的支付方式进行支付。前述使用费不包含其它任何税款、费用或相关汇款等支出，否则您应补足付款或自行支付该费用。您应自行承担因使用本服务所产生的费用，包括不限于上网流量费、通信服务费、功能使用费等。
        </p>
        <p>
          3、如您选择用移动手机支付方式提交订单，即视为您愿意支付移动手机支付服务商的通道费，如有任何问题，您应与移动手机支付服务商协商。
        </p>

        <p class="title">七、知识产权</p>
        <p>
          1、
          <span class="highlight">
            在本协议项下，我们授予您个人的、不可转让的、不可转授权的、可撤销的、非独家的、非排他性的普通使用许可，便于您能够以本协议许可的方式使用本服务。
          </span>
          本协议并不授予您使用我们拥有专有权的界面及其它知识产权,及设计、开发、制造、授予许可或分发第三方装置与配件或第三方应用软件使用的任何权利。
        </p>
        <p>
          2、您了解及同意，除非本公司另行声明，本服务包含的所有产品、技术、软件、程序、数据及其他信息(包括但不限于文字、图像、图片、照片、音频、视频、图表、色彩、版面设计、电子文档、全部免费/付费模板）的所有知识产权(包括但不限于版权、商标权、专利权、商业秘密等)及相关权利均归公司或其关联公司或第三方权利人所有。除公司或第三方权利人明示同意外，您无权复制、传播、转让、许可或提供他人使用上述资源，您无权将本服务项下的资料、内容等用于任何商业或非商业目的，否则应承担相应的责任。
        </p>
        <p>
          3、您承诺不会或促使他人复制(本协议明示允许除外)、反汇编、倒序制造、拆装、企图导出其源代码、解码、修改我们的软件或制造其衍生作品、或我们的软件提供的任何服务或其任何部分（适用法律或可能包含在我们的软件内的开放源代码组件使用协议条款禁止除外）。
        </p>
        <p>
          4、本服务涉及的Logo、文字图形及其组成，以及本服务其他标识、徽记、产品和服务名称均为公司及其关联公司在中国和其它国家的商标，用户未经公司书面授权不得以任何方式展示、使用或作其他处理，也不得向他人表明您有权展示、使用、或作其他处理
        </p>
        <p class="highlight">
          5、未经公司和/或相关权利人的授权许可，您不得以获取直接或间接经济利益为目的，采取任何方式使用本服务（包括但不限于本服务项下的模板）的全部信息内容。如因您违反本条款，侵害公司和/或相关权利人的权利时，公司有权针对因您前述行为所导致的损失要求您承担赔偿责任。
        </p>

        <p class="title">八、变更及免责条款</p>
        <p>1、公司有权对本服务的服务及权益内容、服务价格等随时进行更新、调整。</p>
        <p class="highlight">
          2、鉴于互联网服务的特殊性，您同意公司有权随时变更、中断或终止部分或全部本服务。公司保留随时修改或中断服务而无需通知您的权利，对于由此而造成的任何损失，公司无需对您或任何第三方承担责任。
        </p>
        <p class="highlight">
          3、不论在何种情况下，公司均不对由于internet连接故障、电脑、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、生产力或生产资料不足、火灾、洪水、风暴、爆炸、不可抗力、战争、政府行为、国际、国内法院的命令或第三方的不作为而造成的不能服务或延迟服务承担由此对您造成的任何损失、损害或退还任何您已支付的服务费用等责任。
        </p>
        <p class="highlight">
          4、如您存在违反本协议的情形，公司有权在不通知您的情况下立即终止您已购买的所有服务，且无须退还任何您已支付的服务费用，您应当赔偿公司及关联公司因此遭受的全部损失。
        </p>
        <p class="title">九、投诉和联系方式</p>
        <p>
          1、如您对本协议或使用我们的服务相关的事宜有任何问题（包括问题咨询、投诉等），请通过voicemaker-service@mobvoi.com邮箱与我们联系，我们会在收到您的意见及建议后尽快向您回复。
        </p>
        <p>
          2、您理解并同意，如您被他人投诉或您投诉他人，公司有权将您的信息、联系方式等与投诉相关的信息提供给相关当事方或相关部门。
        </p>
        <p>3、您对您提供的信息、资料等的真实性、合法性、有效性负责。</p>
        <p class="title">十、未成年人使用条款</p>
        <p class="highlight">
          本服务仅面向18周岁以上的成年人。我们要求注册用户是具备完全民事行为能力的自然人，未成年人不得注册自己的用户帐号。我们进一步声明，本服务不面向任何14周岁以下的儿童。
        </p>
        <p class="title">十一、 其他</p>
        <p>
          1、本协议之解释与适用，以及与本协议有关的争议，均应依照中华人民共和国法律予以处理，并以北京市海淀区人民法院为第一审管辖法院。
        </p>
        <p>
          2、本协议之解释与适用，以及与本协议有关的争议，应尽量友好协商解决；协商不成时，则争议各方一致同意将发生的争议提交协商不成时，应依照中华人民共和国法律予以处理，任何一方均可向
          <span class="highlight">北京市海淀区人民法院</span>
          提起诉讼。
        </p>
        <p>3、本协议应取代双方此前就本协议任何事项达成的全部口头和书面协议、安排、谅解和通信。</p>
        <p>
          4、您理解并同意，公司有权自主决定经营策略并根据业务调整情况将本协议项下的全部权利义务并转移给其关联公司，转让将以本协议规定的方式通知，用户承诺对此不持有异议。
        </p>
        <p>5、本协议所有条款的标题仅为阅读方便，不能作为本协议涵义解释之依据。</p>
        <p>6、本协议条款无论因何种原因部分无效或不可执行，其余条款仍继续有效，对各方具有约束力。</p>
        <p>
          7、关联公司：系指北京小问智能科技有限公司在中国地区的关联公司，包括但不限于出门问问创新科技有限公司、北京小问智能科技有限公司，上海羽扇智信息科技有限公司、北京羽扇智信息科技有限公司、问问智能信息科技有限公司、武汉问问智能信息科技有限公司、深圳问问智能信息科技有限公司、出门问问信息科技有限公司、出门问问（武汉）信息科技有限公司、出门问问（苏州）信息科技有限公司、深圳小问智能科技有限公司、南京小问智能科技有限公司。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobile: false,
      isMinip: false,
    };
  },
  methods: {
    checkIsMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      this.isMobile = flag;
    },
  },
  mounted() {
    this.isMobile = this.checkIsMobile();
    let ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('micromessenger') != -1 || ua.indexOf('miniProgram') != -1) {
      //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
      this.isMinip = true;
    }
    if (this.isMobile) {
      document.title = '魔音工坊';
    }
  },
};
</script>

<style lang="less" scoped>
.protocol-container {
  font-size: 16px;
  width: 100%;
  overflow: auto;
  height: 100vh;
  background: #fff;
  color: #1f2329 !important;
  .highlight {
    font-weight: 800;
  }

  .protocol {
    min-width: 470px;
    max-width: 790px;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 20px;
    margin: 20px auto;
    background: #fff;
    box-shadow: 0px 0px 11px 0px rgba(63, 95, 150, 0.04);
    .title {
      width: 100%;
      margin: 36px 0 22px;
      text-align: center;
      font-size: 34px;
      font-weight: 500;
      color: #1f2329;
    }
    .update-data {
      padding: 12px 0;
      text-align: center;
      .time {
        font-size: 16px;
        font-weight: 800;
        text-align: left;
      }
    }
    .container {
      margin-top: 20px;
      .title {
        font-size: 16px;
        margin-top: 32px;
        font-weight: 800;
        text-align: left;
      }
      .time {
        text-align: left;
      }
      p {
        margin-bottom: 20px;
        .highlight {
          font-weight: 800;
        }
        a {
          color: #5a92f4;
        }
        &.compact {
          margin-bottom: 0px;
        }
        &.flex {
          display: flex;
          > span:nth-child(2) {
            margin-left: 1em;
          }
        }
        .q {
          margin-left: 1em;
        }
      }
      .update-data {
        .time {
          font-weight: 800;
        }
        p {
          font-weight: 800;
        }
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .protocol {
    width: 80%;
  }
}
// @media screen  and (max-width: 1400px){
//   .protocol{
//     width:80%
//   }
// }
@media screen and (max-width: 1279px) {
  .protocol {
    width: 70%;
  }
}
@media screen and (max-width: 900px) {
  .protocol {
    width: calc(100% - 40px);
  }
}
.protocol-container {
  &.mobile:not(.minip) {
    .protocol {
      min-width: auto;
      max-width: none;
      border-radius: 4rpx;
      height: auto;
      box-sizing: border-box;
      padding: 0;
      margin: 20rpx auto !important;
      background: #fff;
      box-shadow: 0px 0px 11rpx 0px rgba(63, 95, 150, 0.04);
      .title {
        width: 100%;
        margin: 36rpx 0 22px;
        text-align: center;
        font-size: 34rpx;
        font-weight: 500;
        color: #1f2329;
      }
      .update-data {
        padding: 12rpx 0;
        text-align: center;
      }
      .container {
        margin-top: 20rpx;
        .title {
          font-size: 16rpx;
          margin-top: 32rpx;
          font-weight: 800;
          text-align: left;
        }
        .time {
          text-align: left;
        }
        p {
          margin-bottom: 20rpx;
          .highlight {
            font-weight: 800;
          }
          a {
            color: #5a92f4;
          }
          &.compact {
            margin-bottom: 0px;
          }
          &.flex {
            display: flex;
            > span:nth-child(2) {
              margin-left: 1em;
            }
          }
          .q {
            margin-left: 1em;
          }
        }
        .update-data {
          .time {
            font-weight: 800;
          }
          p {
            font-weight: 800;
          }
        }
      }
    }
  }
  &.mobile {
    &.minip {
      .protocol {
        min-width: auto;
        max-width: none;
        margin: 0 auto;
        width: 100%;
        font-size: 3.4rem;
        .title {
          font-size: 3.4rem;
        }
        .update-data {
          font-size: 1.6rem;
        }
        .container {
          font-size: 1.9rem;
          .title {
            font-size: 2rem;
          }
          &.flex {
            display: flex;
            > span:nth-child(2) {
              margin-left: 1rem;
            }
          }
          .q {
            margin-left: 1rem;
          }
        }
      }
    }
  }
}
</style>
